import { FC } from "react";
import { AccountFormProvider } from "./account";
import { BudgetFormProvider } from "./budget";
import { CompanyFormProvider } from "./company";
import { CustomerFormProvider } from "./customer";
import { ModelFormProvider } from "./importModel";
import { TagFormProvider } from "./tag";
import { TransactionFormProvider } from "./transaction";

export const FormProviders: FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <ModelFormProvider>
    <TagFormProvider>
      <AccountFormProvider>
        <BudgetFormProvider>
          <CompanyFormProvider>
            <CustomerFormProvider>
              <TransactionFormProvider>{children}</TransactionFormProvider>
            </CustomerFormProvider>
          </CompanyFormProvider>
        </BudgetFormProvider>
      </AccountFormProvider>
    </TagFormProvider>
  </ModelFormProvider>
);
